export default {
  activeStep: 1,
  emails: null,
  variables: null,
  settings: {
    subject: '',
    greeting: '',
    text: '',
  },
  template: null,
  isLoading: false,
  isSubmitting: false,
  errors: null,
  validationErrors: null,
};
